import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import i18n from './i18n/index';
import * as Formated from './filters/format'
import * as Dates from './filters/dates'
import * as firebase from 'firebase/app'
import * as Sentry from "@sentry/vue";
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
});

if (process.env.VUE_APP_SENTRY_DSN && process.env.VUE_APP_VERSION ) {
	Sentry.init({
		Vue,
		release: process.env.VUE_APP_VERSION,
		dsn: process.env.VUE_APP_SENTRY_DSN,
		integrations: [
			Sentry.browserTracingIntegration({ router }),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 0.1, // Reduce el muestreo en producción
		tracePropagationTargets: [/^https:\/\/[a-zA-Z0-9-]+\.hiperpbx\.com/, "localhost"],
		replaysSessionSampleRate: 0.05,
		replaysOnErrorSampleRate: 0.5,
		beforeSend: (event, hint) => {
			const exception = hint.originalException
			if (exception.name === 'NavigationDuplicated') {
				return null
			}

			return event
		}
	});
} else {
	console.warn('Sentry no está configurado correctamente.');
}

if (process.env.VUE_APP_GTM_ID) {
	Vue.use(VueGtm, {
		id: process.env.VUE_APP_GTM_ID,
		defer: false,
		enabled: true,
		debug: false,
		loadScript: true,
		vueRouter: router,
		trackOnNextTick: false,
	});
}

Vue.config.productionTip = false;

Vue.filter('utf8', Formated.decode)
Vue.filter('calendar', Dates.calendar)
Vue.filter('chat', Dates.chatRedeableDate)
Vue.filter('hhmmss', Dates.secondsToFormat)
Vue.filter('redeableDate', Dates.redeableDate)
Vue.filter('firstLetter', Formated.firstLetter)
Vue.filter('usersWriting', Formated.usersWriting)
Vue.filter('hhmm', Dates.secondsToHourMinutes)
Vue.filter('date', Dates.secondsToDate)
Vue.filter('ticketDate', Dates.ticketDate)

let app;

const firebaseConfig = {
	apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
	appId: process.env.VUE_APP_FIREBASE_APPID,
	measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENTID,
};

firebase.initializeApp(firebaseConfig);

store.commit("SET_FIREBASE", firebase);
store.commit("SET_CONFIGURACTION", firebaseConfig);

firebase.auth().onAuthStateChanged((user) => {
	if (!app) {
		document.querySelector('#pre-loading').remove()
		app = new Vue({
			i18n,
			router,
			store,
			render: (h) => h(App),
		}).$mount("#app");
	}

	if (!user) {
		document.cookie = 'hiper_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=None; Secure';
		localStorage.removeItem("osticket_token")
		localStorage.removeItem("osticket_staff")
		localStorage.removeItem("lang")
	}

	store.commit("SET_FIREBASE_USER", user);
});